import { createFileRoute } from '@tanstack/react-router';
import Tasks from '@src/pages/Tasks';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/tasks')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('tasks.page_title', 'Tasks') }],
  }),
  component: Tasks,
});
